import { request, getCookie, setCookie } from "../axios/request";
import * as queryParams from "qs";

import { fetchCurrentStaff } from "./navHeader";

import {
  FETCH_STORES_PENDING,
  FETCH_STORES_REJECTED,
  FETCH_STORES_FULFILLED,
  AUTH_PENDING,
  AUTH_REJECTED,
  FETCH_STAFFS_PENDING,
  FETCH_STAFFS_FULFILLED,
  ACTIVATE_STAFF_REJECTED,
  ACTIVATE_STAFF_FULFILLED,
} from "../constants/auth";

import { REMOVE_CUSTOMER_DETAIL } from "../constants/customerDetail";
import { removeAuthSession } from "theme/utils";

const $U = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/urls`);

const pending = () => ({
  type: FETCH_STORES_PENDING,
});

const authPending = () => ({
  type: AUTH_PENDING,
});

const staffsPending = () => ({
  type: FETCH_STAFFS_PENDING,
});

const rejected = (error) => ({
  type: FETCH_STORES_REJECTED,
  error: error,
});

const authRejected = (error) => ({
  type: AUTH_REJECTED,
  error: error,
});

const activateStaffRejected = (error) => ({
  type: ACTIVATE_STAFF_REJECTED,
  error: error,
});

const fulfilled = (response) => ({
  type: FETCH_STORES_FULFILLED,
  response: response,
});

const staffsFulfilled = (response) => ({
  type: FETCH_STAFFS_FULFILLED,
  response: response,
});

const activateStaffFulfilled = (response) => ({
  type: ACTIVATE_STAFF_FULFILLED,
  response: response,
});

export const fetchStores = () => (dispatch) => {
  dispatch(pending());

  request({ url: $U.RETAIL_STORES, method: "get" })
    .then((response) => {
      dispatch(fulfilled(response.data));
    })
    .catch((error) => {
      dispatch(rejected(error));
    });
};

export const login = (formData) => (dispatch) => {
  dispatch(authPending());
  setCookie("store_sessionid", getCookie("store_sessionid"), 100000);
  request({
    url: $U.LOGIN,
    method: "POST",
    data: queryParams.stringify({
      email: formData.email,
      password: formData.password,
    }),
  })
    .then(() => {
      dispatch(fetchStaffs());
    })
    .catch((error) => {
      dispatch(authRejected(error));
    });
};

export const logout = () => (dispatch) => {
  dispatch(authPending());

  request({
    url: $U.CUSTOMER_LOGOUT,
    method: "POST",
    data: {},
  })
    .then(() => {
      removeAuthSession();
      dispatch(logoutStaff());
    })
    .catch(() => {
      removeAuthSession();
      dispatch(logoutStaff());
    });
};

const logoutStaff = () => (dispatch) => {
  request({
    url: $U.LOGOUT,
    method: "POST",
    data: {},
  })
    .then(() => {
      //dispatch(fetchCurrentStaff());
      dispatch(fetchStores());
      dispatch({ type: REMOVE_CUSTOMER_DETAIL });
    })
    .catch((error) => {
      dispatch(rejected(error));
    });
};

export const fetchStaffs = () => (dispatch) => {
  dispatch(staffsPending());

  request({ url: $U.STAFFS, method: "get" })
    .then((response) => {
      dispatch(staffsFulfilled(response.data));
    })
    .catch((error) => {
      dispatch(rejected(error));
    });
};

export const activateStaff = (staffId) => (dispatch) => {
  dispatch(pending());
  request({
    url: `/staffs/${staffId}/activate/`,
    method: "POST",
  })
    .then((response) => {
      dispatch(activateStaffFulfilled(response.data));
      dispatch(fetchCurrentStaff());
    })
    .catch((error) => {
      dispatch(activateStaffRejected(error));
    });
};



// WEBPACK FOOTER //
// ./src/actions/auth.js